import { apiPostRequest } from '../apiRequests';

interface Params {
  result_id: string;
  reference_id: string;
}

interface ResponseData {
  result_id: string;
  reference_id: string | null;
}

interface ResponseMeta {
  /**
   * True when the API also wrote the reference to the user record, which makes it durable
   * through an address-change re-mint. Lets the client release its localStorage buffer early.
   */
  reference_bound_to_user?: boolean;
}

/**
 * Public endpoint — the reference is captured before any account exists, and most of the
 * shopping journey is anonymous.
 */
export function bindReference(params: Params) {
  return apiPostRequest<ResponseData, ResponseMeta>('order/reference', params);
}
